import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Footer from "../../main/footer";
import Nav from "../../main/header";
import Error404 from "../../pages/Error404";

// Generate avatar when image is empty
const generateAvatar = (name, size = 200) => {
    if(name == "") {
        return "/assets/images/retail-store-icon.png"; 
    }
    const words = name.trim().split(/\s+/);
    const initials = words.length > 1 
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase() 
        : words[0][0].toUpperCase();
    const generateColorFromName = (name) => {
        let hash = 2166136261;
        for (let i = 0; i < name.length; i++) {
            hash ^= name.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }
        const r = (hash & 0xFF0000) >> 16;
        const g = (hash & 0x00FF00) >> 8;
        const b = hash & 0x0000FF;
        return `rgb(${r}, ${g}, ${b})`;
    };

    const bgColor = generateColorFromName(name);
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);
    ctx.fillStyle = '#ffffff';
    ctx.font = `${size / 2}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initials, size / 2, size / 2);
    return canvas.toDataURL('image/png');
};

function Cat() {
    const [vendor, setVendor] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const spplier = params.get("name") || ""; // default to empty string
        ShowData(spplier);
    }, []);

    const ShowData = async (spplier) => {
        const data = new FormData();
        data.append("key", spplier);
        data.append("val", "supplier");
        axios({
            method: "post",
            url: "/pro/manage_search.php",
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((s) => {
            setVendor(s.data);
            setHasFetched(true);
        })
        .catch((s) => {
            console.log("Error fetching data", s);
        });
    };

    return (
<div>
  <Nav />
  <link
    href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
    rel="stylesheet"
  />
  <div className="container" style={{ minHeight: "60vh" }}>
    <h3 className="text-center mt-4 main-heading-style">Supplier List</h3>
    <div className="row">
      {hasFetched && vendor.length === 0 ? (
        <Error404 message={"Not found"} />
      ) : (
        vendor.length === 0 && <Error404 message={"Please Wait..."} />
      )}
      {vendor.map(
        (v, i) =>
          i <= 120 && (
            <div className="col-xl-3 col-lg-4 col-sm-6 mb-4 d-flex" key={v.id}>
              <div className="card p-0 supplier-card w-100">
                <div className="card-body d-flex flex-column justify-content-between">
                  <div className="supplier-avatar-container">
                    <div
                      className="supplier-avatar"
                      style={{
                        backgroundImage: `url(${
                          v.image_src || generateAvatar(v.cname || v.name)
                        })`,
                        border: "1px solid #4f97a1", // override white border
                      }}
                    ></div>
                  </div>
                  <div className="supplier-details">
                    <h5 className="supplier-name">{v.cname || ""}</h5>
                    {v.cname && (
                      <p className="supplier-city">Owner: {v.name || ""}</p>
                    )}
                    <p className="supplier-city">City: {v.city || ""}</p>
                    {/* <p className="supplier-phone">Phone: {v.phone || ""}</p> */}
                    <p className="supplier-profile-link">
                      <a
                        href={`companydetail/${v.id}/${v.cname || v.name || ""}`}
                        className="custom-theme-button m-0"
                      >
                        Visit Profile
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )
      )}
    </div>
  </div>
  <Footer />
</div>

    );
}

export default Cat;
